import request from "../plugins/request";

/** 获取火点历史排名 */
export const getFireWarningHistoryRanking = (params) =>
  request({
    url: "/api/dataCenter/getFireWarningHistoryRanking",
    method: "get",
    params
  });

/** 获取火点历史数据 */
export const getFireWarningListPage = (params) =>
  request({
    url: "/api/dataCenter/getFireWarningListPage",
    method: "get",
    params
  });

/**
 * 关联挖掘(散点图)
 * @tutorial http://yapi.guanyingis.com/project/209/interface/api/5129
 */
export const getAlarmrelationaqiData = (params) => {
  params.project_no = 'GYHB2022SS04'
  return request({
    baseURL: "https://ai.guanyingis.com",
    url: "/api/aqi/app/alarmrelationaqi",
    method: "get",
    loading: false,
    params,
  });
};

/** 数据分析-乡镇统计 */
export const getDataAnalysisTownData = (params) =>
  request({
    url: "/api/dataCenter/getDataAnalysisTownData",
    method: "get",
    params
  });

/** 数据分析-点位统计 */
export const getDataAnalysisPointData = (params) =>
  request({
    url: "/api/dataCenter/getDataAnalysisPointData",
    method: "get",
    params
  });
